module.exports = __webpack_public_path__ + "static/media/pointer-1.caaf8376.svg";